module.exports = __webpack_public_path__ + "assets/img/dzh-2.7e8b3e60.jpg";